import { assignSafe } from '@summit/core';

export class SortAttribute<T> {
  id: keyof T & string;
  start: 'asc' | 'desc' | null;
  constructor(jsonData?: Partial<SortAttribute<T>>) {
    if (jsonData) {
      assignSafe(this, jsonData);
    }
  }
}
